module.exports = __webpack_public_path__ + "img/logo.bb60acc0.svg";